import 'ag-grid-enterprise/styles/ag-grid.css';
import 'ag-grid-enterprise/styles/ag-theme-alpine.css';

import { ModuleRegistry, AllCommunityModule, provideGlobalGridOptions } from 'ag-grid-community';
import { AllEnterpriseModule, LicenseManager, ServerSideRowModelModule } from 'ag-grid-enterprise';

// Register all modules - explicitly include ServerSideRowModelModule
ModuleRegistry.registerModules([AllCommunityModule, AllEnterpriseModule, ServerSideRowModelModule]);

// This app themes grids via the legacy CSS files (ag-grid.css + ag-theme-alpine
// imported below, plus .ag-theme-alpine overrides in App.css). In AG Grid v33+
// the Theming API is the default, so loading the CSS files alongside it triggers
// error #239. Opt every grid into the legacy theme globally so the CSS path is
// authoritative and #239 stops firing.
provideGlobalGridOptions({ theme: 'legacy' });

// AG Grid keys are deliberately supplied at build time. They are client-side
// licence identifiers (not server credentials), but keeping them outside the
// repository makes expiry/renewal rotation explicit and avoids committing old
// evaluation keys.
const agGridLicenseKey = process.env.REACT_APP_AG_GRID_LICENSE_KEY?.trim();
if (agGridLicenseKey) {
  LicenseManager.setLicenseKey(agGridLicenseKey);
}
